<div class="inner-card flow-root column">
  <form class="filter-form  dis-flex" [formGroup]="LeaveSelectionFilterForm" fxLayout="row wrap" fxLayout.xs="column"
    fxLayoutAlign="start end" fxFlex.gt-sm="100">
    <app-employee-filter></app-employee-filter>

    <app-date-period-filter [IsBothDatesRequired]="false" [DateType]="DateFilterType.Common"
      [PeriodFrom]="CommonDateFrom" [PeriodTo]="CommonDateTo"
      (FromDateChanged)="SetFilterValues('commonDateFrom', $event)"
      (ToDateChanged)="SetFilterValues('commonDateTo', $event)">
    </app-date-period-filter>

    <app-ordern-filter (OrdernChange)="SetFilterValues('Ordern',null,$event)" class="mr-20"></app-ordern-filter>

    <div fxFlex.gt-sm="16" fxFlexAlign="center" id="leave-selection-active-leaves">
      <mat-checkbox formControlName="ActiveLeaves" (ngModelChange)="SetFilterValues('activeLeaves')">Sólo bajas activas
      </mat-checkbox>
    </div>

    
    <div class="mr-20" fxFlex.gt-sm="16" fxFlexAlign="center" id="emp-selection-bajas-empresa">
      <mat-checkbox formControlName="EmpresaSelec" (ngModelChange)="SetFilterValues('empresaSelec')">Solo empresa seleccionada
      </mat-checkbox>
    </div>

  </form>
</div>